{
  "ancillaries": {
    "overlappingServicesNotification": {
      "convertMultipleServicesToBundle": "Combine your selections into a combo and get a 10% combo discount:",
      "convertServiceToSeatBundle": "This combo adds a seat to your selected {overlapCategory} - with a 10% combo discount.",
      "convertSeatBundleToSeatBundle": "You can add one combo per seat. Switching will replace your {overlapCategory} combo with {currentCategory} combo. Your seat stays the same.",
      "convertSeatBundleToSeat": "Adding a seat will remove your currently selected {overlapCategory} combo.",
      "removeServiceFromBundle": "Adding a different {currentCategory} will remove your selected {overlapCategory} combo.",
      "removeServiceFromSeatBundle": "Adding a different {currentCategory} will remove the {currentCategory} included in your combo. Your seat stays the same, but will no longer include the 10% combo discount.",
      "replaceMultipleServicesWithBundle": "Adding this combo will remove your current selections, which are:",
      "replaceServiceWithBundle": "Adding this {currentCategory} combo will remove your current {overlapCategory}."
    },
    "seatWifi": { "genericTitle": "Seat + Internet" },
    "seatPriority": { "genericTitle": "Seat + Priority" },
    "seatCabinBaggage": { "genericTitle": "Seat + Carry-on" },
    "seatMeal": { "genericTitle": "Seat + Meal" },
    "loungeCabinBaggage": { "genericTitle": "Lounge + Carry-on" },
    "loungePriority": { "genericTitle": "Lounge + Priority" },
    "loungeWifi": { "genericTitle": "Lounge + Internet" },
    "wifiMeal": { "genericTitle": "Internet + Meal" },
    "seatCombos": {
      "eligibility": {
        "preOrderMealsAvailablePrior36Hours": "Pre-order meals are available for purchase up until 36 hours before departure.",
        "preOrderMealsAvailablePrior16Hours": "Pre-order meals are available for purchase up until 16 hours before departure.",
        "freshMealsAvailablePrior24Hours": "Fresh meals are available for purchase up until 24 hours before departure.",
        "freshMealsAvailablePrior7Hours": "Fresh meals are available for purchase up until 7 hours before departure."
      }
    },
    "ancillaryCombos": {
      "eligibility": {
        "preOrderMealsAvailablePrior36Hours": "Pre-order meals are available for purchase up until 36 hours before departure.",
        "preOrderMealsAvailablePrior16Hours": "Pre-order meals are available for purchase up until 16 hours before departure.",
        "freshMealsAvailablePrior24Hours": "Fresh meals are available for purchase up until 24 hours before departure.",
        "freshMealsAvailablePrior7Hours": "Fresh meals are available for purchase up until 7 hours before departure."
      }
    },
    "quota": {
      "onlyQuotaLeft": {
        "singular": "Only one left",
        "plural": "{quota} left"
      },
      "quotaLeft": {
        "singular": "1 left",
        "plural": "{quota} left"
      },
      "noQuotaLeft": "None left"
    },
    "meals": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Only {amount} meal left",
            "plural": "Only {amount} meals left"
          },
          "description": "Pick your meal before they run out."
        },
        "allSelected": {
          "title": "No meals left",
          "description": "You have selected for everyone in the booking."
        },
        "shortForGroup": {
          "title": {
            "singular": "Only {amount} pre-order meal left for your group of {passengerCount}",
            "plural": "Only {amount} pre-order meals left for your group of {passengerCount}"
          },
          "description": "Onboard space for meals is limited on this flight.",
          "noneLeft": "No pre-order meal left."
        },
        "takenByOtherPassenger": "You've added the last available pre-order meal to another passenger."
      }
    },
    "priority": {
      "detailsLinkTitle": "Priority details",
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Only {amount} priority service left",
            "plural": "Only {amount} priority services left"
          },
          "description": "Get yours and travel smoother."
        },
        "allSelected": {
          "title": "No priority services left",
          "description": "You have selected for everyone in the booking."
        },
        "shortForGroup": {
          "title": {
            "singular": "Only {amount} priority service left for your group of {passengerCount}",
            "plural": "Only {amount} priority services left for your group of {passengerCount}"
          },
          "description": "Availability is limited, so priority truly delivers less time waiting.",
          "noneLeft": "No more priority services available."
        },
        "takenByOtherPassenger": "You've added the last available priority service to another passenger."
      }
    },
    "meal": {
      "detailsLinkTitle": "Meal details"
    },
    "cabinBaggage": {
      "detailsLinkTitle": "Carry-on details"
    },
    "lounge": {
      "detailsLinkTitle": "Lounge details"
    },
    "sport": {
      "quota": {
        "exhausted": {
          "default": "No more space for this product left on this flight.",
          "BIKE": "No more space for bicycles left on this flight.",
          "GOLF": "No more space for golf equipment left on this flight.",
          "SKIS": "No more space for skiing equipment left on this flight.",
          "SURF": "No more space for surfboards left on this flight."
        },
        "takenByOtherPassenger": {
          "default": "You've already added the last one of this product for another passenger.",
          "BIKE": "You've already added the last bicycle for another passenger.",
          "GOLF": "You've already added the last set of golf equipment for another passenger.",
          "SKIS": "You've already added the last set of skiing equipment for another passenger.",
          "SURF": "You've already added the last surfboard for another passenger."
        }
      }
    },
    "tags": {
      "bestPriceNow": ""
    },
    "toaster": {
      "errorSavingBundle": "",
      "errorSavingSeatWifi": "We were unable to save your changes to your Seat + Internet combo. Please try again.",
      "errorSavingSeatPriority": "We were unable to save your changes to your Seat + Priority combo. Please try again.",
      "errorSavingSeatCabinBaggage": "We were unable to save your changes to your Seat + Carry-on combo. Please try again.",
      "errorSavingSeatMeal": "We were unable to save your changes to your Seat + Meal combo. Please try again.",
      "errorSavingLoungeCabinBaggage": "We were unable to save your changes to your Lounge + Carry-on combo. Please try again.",
      "errorSavingLoungePriority": "We were unable to save your changes to your Lounge + Priority combo. Please try again.",
      "errorSavingLoungeWifi": "We were unable to save your changes to your Lounge + Internet combo. Please try again.",
      "errorSavingWifiMeal": "We were unable to save your changes to your Internet + Meal combo. Please try again."
    }
  },
  "payment": {
    "paymentCard": {
      "brand": {
        "RP": "RuPay"
      }
    },
    "paymentMethod": {
      "BLIK": "BLIK",
      "PAYTRAIL": "Paytrail",
      "WERO": "Wero",
      "APEXX_PAYMENT_CARD": "Credit or debit card"
    }
  }
}
